import { z } from "zod";

enum PremiumFeatures {
  EDITS = "EDITS",
  SCHEDULE = "SCHEDULE",
  GEMS = "GEMS",
}

const premiumFeatureSchema = z.object({
  feature: z.nativeEnum(PremiumFeatures),
  cancel_button_title: z.string().optional().nullable().catch(null),
  cta: z.string().optional().nullable().catch(null),
  message: z.string().optional().nullable().catch(null),
  subtext: z.string().optional().nullable().catch(null),
  title: z.string().optional().nullable().catch(null),
  url: z.string().catch(""),
});

type PremiumFeature = z.infer<typeof premiumFeatureSchema>;

export { premiumFeatureSchema, type PremiumFeature, PremiumFeatures };
